import { setExaminerProfileModal, setSelectedApplicantsIds } from '../../../../../store/workspace/slice';
import { selectSelectedApplicantsIds } from '../../../../../store/workspace/selectors';
import { getExaminerProfileThunk } from '../../../../../store/workspace/thunks';
import { ChevronDownIcon, ProfileIcon } from '../../../../../assets/icons';
import { ForwardedRef, forwardRef, MouseEvent, useState, } from 'react';
import { ExaminerProfile } from '../../../../../store/workspace/types';
import { examStatusTitle } from '../../../../../utils/generalHelpers';
import { useDispatch, useSelector } from '../../../../../store/store';
import CheckBox from '../../../../../components/CheckBox';
import styles from './style.module.scss';

interface Props {
    examinersData: ExaminerProfile[];
    jobId: string | undefined;
};

const InterviewTable = forwardRef((props: Props, ref: ForwardedRef<HTMLDivElement>) => {
    const {
        examinersData,
        jobId,
    } = props;

    const dispatch = useDispatch();
    const selectedApplicantsIds = useSelector(selectSelectedApplicantsIds);
    const [expandedCards, setExpandedCards] = useState<string[]>([]);

    const toggleCard = (userId: string) => {
        setExpandedCards(prev => {
            if (prev.includes(userId)) {
                return prev.filter(id => id !== userId);
            } else {
                return [...prev, userId];
            }
        });
    };

    const selectExaminer = (examinerId: string) => {
        const check = selectedApplicantsIds.some(i => i === examinerId);
        let list = [...selectedApplicantsIds];

        if (check) {
            list = list.filter(i => i !== examinerId);
        } else {
            list.push(examinerId);
        }

        dispatch(setSelectedApplicantsIds(list));
    };

    const selectAllExaminers = () => {
        const check = selectedApplicantsIds.length === examinersData.length;
        const newList = check ? [] : examinersData.map(i => i.userId);
        dispatch(setSelectedApplicantsIds(newList));
    };

    const getExaminerProfile = (e: MouseEvent<HTMLTableCellElement>, id: string) => {
        e.stopPropagation();
        dispatch(getExaminerProfileThunk({ id, jobId }));
        dispatch(setExaminerProfileModal(true));
    };

    return (
        <div className={styles.container}>
            <div className={styles.table} ref={ref}>
                <table>
                    <thead>
                        <tr>
                            <th colSpan={6}>
                                <div className={styles.select_all}>
                                    <CheckBox
                                        onClick={selectAllExaminers}
                                        checked={examinersData.length !== 0 && examinersData.length === selectedApplicantsIds.length}
                                    />
                                    <span>Select All ({examinersData.length})</span>
                                </div>
                            </th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Email</th>
                            <th>Phone Number</th>
                            <th>Location</th>
                            <th data-noprint="true">Info</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(examinersData && examinersData.length > 0) ? examinersData.map(i => <tr>
                            <td>
                                <div className={styles.examinerName}>
                                    <CheckBox
                                        onClick={() => selectExaminer(i.userId)}
                                        checked={selectedApplicantsIds.some(item => item === i.userId)}
                                    />
                                    <span> {i.first_name} {i.family_name}</span>
                                </div>
                            </td>
                            <td>
                                <span
                                    className={styles.status}
                                    data-status={i.status}
                                >
                                    {examStatusTitle(i.status)}
                                </span>
                            </td>
                            <td>{i.email}</td>
                            <td>{i.phone_number}</td>
                            <td>{i.city} / {i.state}</td>
                            <td data-noprint="true" onClick={(e) => getExaminerProfile(e, i.userId)}><ProfileIcon /></td>
                        </tr>) : <tr>
                            <td colSpan={5}>No data.</td>
                        </tr>}
                    </tbody>
                </table>
            </div>
            <div className={styles.mobile_list}>
                {examinersData.map(i => {
                    const isExpanded = expandedCards.includes(i.userId);
                    return (
                        <div className={styles.card}>
                            <div className={styles.card_header} onClick={() => toggleCard(i.userId)}>
                                <span>{i.first_name} {i.family_name}</span>
                                <ChevronDownIcon style={{ transform: isExpanded ? 'rotate(180deg)' : 'none' }} />
                            </div>
                            {isExpanded && <div className={styles.card_body}>
                                <div className={styles.card_body_section}>
                                    <div className={styles.card_body_section_title}>
                                        <span>Status</span>
                                        <span className={styles.status} data-status={i.status}>
                                            {examStatusTitle(i.status)}
                                        </span>
                                    </div>
                                </div>
                                <div className={styles.card_body_section}>
                                    <div className={styles.card_body_section_title}>
                                        <span>Email</span>
                                        <span>{i.email}</span>
                                    </div>
                                </div>
                                <div className={styles.card_body_section}>
                                    <div className={styles.card_body_section_title}>
                                        <span>Phone Number</span>
                                        <span>{i.phone_number}</span>
                                    </div>
                                </div>
                                <div className={styles.card_body_section}>
                                    <div className={styles.card_body_section_title}>
                                        <span>Location</span>
                                        <span>{i.city} / {i.state}</span>
                                    </div>
                                </div>
                            </div>}
                        </div>
                    )
                })}
            </div>
        </div>
    );
});

export default InterviewTable;
